// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as zod from "zod";
import { default as dayjs } from "dayjs";

const closedDateSchema = zod.custom<dayjs.Dayjs>(
  value => dayjs.isDayjs(value) && value.isValid(),
  { message: "GeÃ§erli bir Day.js nesnesi deÄŸil veya formatÄ± doÄŸru deÄŸil." }
);
const validatePosList = (obj: any) => {
  // obj'in en az bir anahtar-deÄŸer Ã§iftine sahip olup olmadÄ±ÄŸÄ±nÄ± kontrol eder
  return Object.values(obj).some(val => val === true);
};
export const firstStepFormSchema = zod.object({
  paymentDescriptionPlaceholder: zod.any(),
  parentMerchantId: zod.any().optional(),
  merchantStatusType: zod.string()
    .min(1, { message: "Please enter your phone number" }),
  annulmentStaff: zod.any().optional().nullable(),
  annulmentCode: zod.string().optional().nullable(),
  passiveReason: zod.string().optional().nullable(),
  closedDate: zod.any().optional().nullable(),
  merchantType: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  posList: zod.object({
    vpos: zod.boolean().optional(),
    pos: zod.boolean().optional(),
    mobilePos: zod.boolean().optional(),
    cepPos: zod.boolean().optional(),
  }).refine(validatePosList, {
    message: "En az bir POS Tipi seÃ§melisiniz!",
  }),
  integrationTypeId: zod.string().min(1, { message: "Please enter valid integration id" }),
  merchantName: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  tradeName: zod.string().min(1, { message: "Please enter your phone number" }),
  tradeRegistrationNumber: zod.string().min(1, { message: "Please enter your trade registration number" }),
  commissionProfileCode: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  webSite: zod.string().min(1, { message: "Please enter your phone number" }),
  taxNumber: zod
    .string()
    .length(10, { message: "Must be exactly 10 characters long" }),
  taxOfficeCode: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  citizenshipNumber: zod.string().optional(),
  mcc: zod.string().min(1),
  originalMcc: zod.string().min(1, { message: "Original MCC alanÄ± zorunludur" }),
  // mcc: zod.any().refine(value => typeof value === 'string' || typeof value === 'number', {
  //   message: 'mcc should be a string or a number',
  // }),
  hostingCompanyName: zod
    .union([
      zod.string().min(6),
      zod.literal(""),
      zod.literal(null),
      zod.literal(undefined)
    ])
    .optional()
    .transform(e => e === "" ? undefined : e),

  hostingCompanyCitizenNumber: zod.union([
    zod.string().length(0, { message: "Must be empty or 10-11 characters long" }),
    zod.string()
      .min(10, { message: "Must be at least 10 characters long" })
      .max(11, { message: "Must be at most 11 characters long" })
  ]).optional().nullable(),

  openingDate: zod.any(),
  aggreementDate: zod.any().optional(),
  foundationDate: zod.any(),
  // closedDate: zod.any().optional(),
  city: zod.union([
    zod.null().nullable(),
    zod.object({
      // Burada objenizin Ã¶zelliklerini belirleyebilirsiniz
      label: zod.string(),
      value: zod.string(),
    }),
  ]).refine(value => value !== null && value !== undefined, {
    message: "Bu alanÄ±n boÅŸ bÄ±rakÄ±lamaz.",
  }),
  userPortfolioId: zod.string().min(1, { message: "User Portfolio Id is required" }),
  linkQuantity: zod.any().optional().default(1),
  linkPaymentHour: zod.any().optional().default(1),
  hasGiroRestriction: zod.any().optional().default(false),
  hasAutomaticGiroLimitIncrease: zod.any().optional().default(false),
  giroLimit: zod.any().optional(),
  commercialFlag: zod.any().optional().default(false),
  corporateFlag: zod.any().optional().default(false),
  sectorId: zod.any().optional(),
  isInvoiceSendAsEmailEnabled: zod.boolean().optional().default(false),
  invoiceEmail: zod.string().optional()
    .refine((val) => {
      if (val?.isInvoiceSendAsEmailEnabled) {
        return val && val?.length > 0;
      }
      return true;
    }, { message: "Invoice Email is required when Invoice is enabled" }),
  erpCustomerCode: zod.any().optional(),
  integratorId: zod.any().optional(),
  integratorUid: zod.string().optional(),
  integratorPwd: zod.string().optional(),
  integratorGbAlias: zod.string().optional(),
  integratorEArchiveGbAlias: zod.string().optional(),
  walletNo: zod.string().optional(),
  eftDescription: zod.string().optional(),
  paymentBlockedDay: zod.any().optional(),
  blockedDay: zod.any().optional(),
  isPayoutBlocked: zod.any().optional(),
  payoutBlockReason: zod.any().optional(),
  addressLine1: zod.any().optional(),
  addressLine2: zod.any().optional(),
  cityId: zod.any().optional(),
  districtId: zod.any().optional(),
  mobilePhoneNumber: zod.any().optional(),
  zipCode: zod.any().optional(),
  emailAddress1: zod.any().optional(),
  emailAddress2: zod.any().optional(),
  faxNumber: zod.any().optional(),
  addressPhoneNumber: zod.any().optional(),
  vPosIntegrationStatus: zod.string().optional(),
  merchantStatusDescription: zod.any().optional(),
  editorDescription: zod.string().optional(),
  isCallbackUrlControl: zod.boolean().optional(),
  callbackUrl: zod.string().optional().refine(
    (url) => {
      if (!url) return true; // Optional field
      const hasSchema = url.startsWith('http://') || url.startsWith('https://');
      const dotCount = (url.match(/\./g) || []).length;
      return hasSchema && dotCount >= 1;
    },
    {
      message: "Invalid URL. It should start with http:// or https:// and contain a valid domain.",
    }
  ),
  employeeCount: zod.any().optional(),
  estimatedGiro: zod.any().optional(),
}).refine(
  (data) => {
    if (data.isCallbackUrlControl && (!data.callbackUrl || data.callbackUrl.trim() === '')) {
      return false;
    }
    return true;
  },
  {
    message: "Callback URL is required when 'Callback URL Control' is active.",
    path: ['callbackUrl'],
  }
);


export const firstStepFormSchemaPassive = zod.object({
  parentMerchantId: zod.any().optional(),
  merchantStatusType: zod.string()
    .min(1, { message: "Please enter your phone number" }),
  annulmentStaff: zod.any().optional().nullable(),

  closedDate: closedDateSchema,
  merchantType: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  posList: zod.object({
    vpos: zod.boolean().optional(),
    pos: zod.boolean().optional(),
    mobilePos: zod.boolean().optional(),
    cepPos: zod.boolean().optional(),
  }).refine(validatePosList, {
    message: "En az bir POS Tipi seÃ§melisiniz!",
  }),
  merchantName: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  tradeName: zod.string().min(1, { message: "Please enter your phone number" }),
  tradeRegistrationNumber: zod.any().optional(),
  commissionProfileCode: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  webSite: zod.string().min(1, { message: "Please enter your phone number" }),
  taxNumber: zod
    .string()
    .length(10, { message: "Must be exactly 10 characters long" }),
  taxOfficeCode: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  citizenshipNumber: zod.string().optional(),
  mcc: zod.string().min(1),
  originalMcc: zod.string().min(1, { message: "Original MCC alanÄ± zorunludur" }),
  // mcc: zod.any().refine(value => typeof value === 'string' || typeof value === 'number', {
  //   message: 'mcc should be a string or a number',
  // }),
  hostingCompanyName: zod
    .union([
      zod.string().min(6),
      zod.literal(""),
      zod.literal(null),
      zod.literal(undefined)
    ])
    .optional()
    .transform(e => e === "" ? undefined : e),

  hostingCompanyCitizenNumber: zod.union([
    zod.string().length(0, { message: "Must be empty or 10-11 characters long" }),
    zod.string()
      .min(10, { message: "Must be at least 10 characters long" })
      .max(11, { message: "Must be at most 11 characters long" })
  ]).optional().nullable(),

  openingDate: zod.any(),
  aggreementDate: zod.any().optional(),
  foundationDate: zod.any(),
  // closedDate: zod.any().optional(),
  city: zod.union([
    zod.null().nullable(),
    zod.object({
      // Burada objenizin Ã¶zelliklerini belirleyebilirsiniz
      label: zod.string(),
      value: zod.string(),
    }),
  ]).refine(value => value !== null && value !== undefined, {
    message: "Bu alanÄ±n boÅŸ bÄ±rakÄ±lamaz.",
  }),
  annulmentCode: zod.string().optional(),
  passiveReason: zod.string().optional(),
  isPaymentDescriptionActive: zod.any(),
  paymentDescriptionPlaceholder: zod.any(),
  isUnlimitedLink: zod.boolean().default(false),
  integrationTypeId: zod.any().optional(),
  userPortfolioId: zod.any().optional(),
  linkQuantity: zod.any().optional().default(1),
  linkPaymentHour: zod.any().optional().default(1),
  hasGiroRestriction: zod.any().optional().default(false),
  hasAutomaticGiroLimitIncrease: zod.any().optional().default(false),
  giroLimit: zod.any().optional(),
  commercialFlag: zod.any().optional().default(false),
  corporateFlag: zod.any().optional().default(false),
  sectorId: zod.any().optional(),
  isInvoiceEnabled: zod.boolean().optional().default(false),
  invoiceEmail: zod.string().optional()
    .refine((val) => {
      if (val?.isInvoiceSendAsEmailEnabled) {
        return val && val?.length > 0;
      }
      return true;
    }, { message: "Invoice Email is required when Invoice is enabled" }),
  erpCustomerCode: zod.any().optional(),
  integratorId: zod.any().optional(),
  integratorUid: zod.string().optional(),
  integratorPwd: zod.string().optional(),
  integratorGbAlias: zod.string().optional(),
  integratorEArchiveGbAlias: zod.string().optional(),
  walletNo: zod.string().optional(),
  eftDescription: zod.string().optional(),
  addressLine1: zod.any().optional(),
  addressLine2: zod.any().optional(),
  cityId: zod.any().optional(),
  districtId: zod.any().optional(),
  mobilePhoneNumber: zod.any().optional(),
  zipCode: zod.any().optional(),
  emailAddress1: zod.any().optional(),
  emailAddress2: zod.any().optional(),
  faxNumber: zod.any().optional(),
  addressPhoneNumber: zod.any().optional(),
  isPayoutBlocked: zod.any().optional(),
  payoutBlockReason: zod.any().optional(),
  merchantStatusDescription: zod.any().optional(),
  editorDescription: zod.string().optional(),
  employeeCount: zod.any().optional(),
  estimatedGiro: zod.any().optional(),
})
  .refine(
    data => {

      if (data.posList.mobilePos) {
        if (data.integratorId < 0) {
          throw new zod.ZodError([
            { message: "En az bir alan doldurulmalÄ±", path: ['integratorId'] }
          ]);
        }

        if (!data.integratorUid) {
          throw new zod.ZodError([
            { message: "En az bir alan doldurulmalÄ±", path: ['integratorUid'] }
          ]);
        }

        if (!data.integratorPwd) {
          throw new zod.ZodError([
            { message: "En az bir alan doldurulmalÄ±", path: ['integratorPwd'] }
          ]);
        }

        if (!data.integratorGbAlias) {
          throw new zod.ZodError([
            { message: "En az bir alan doldurulmalÄ±", path: ['integratorGbAlias'] }
          ]);
        }

        if (!data.integratorEArchiveGbAlias) {
          throw new zod.ZodError([
            { message: "En az bir alan doldurulmalÄ±", path: ['integratorEArchiveGbAlias'] }
          ]);
        }
      }

      // Ä°ki alan da boÅŸsa
      // if (!data.annulmentCode && !data.passiveReason) {
      //   throw new zod.ZodError([
      //     { message: "En az bir alan doldurulmalÄ±", path: ['annulmentCode'] },
      //     { message: "En az bir alan doldurulmalÄ±", path: ['passiveReason'] }
      //   ]);
      // }

      return true;
    }
  );
export type FirstStepFormValuesType = zod.infer<typeof firstStepFormSchema>;

export const firstStepInitialValues: FirstStepFormValuesType = {
  hostingCompanyName: "",
  hostingCompanyCitizenNumber: "",
  citizenshipNumber: "",
  parentMerchantId: "",
  merchantStatusType: "",
  openingDate: dayjs(),
  aggreementDate: dayjs(),
  foundationDate: "",
  city: null,
  merchantName: "",
  tradeName: "",
  tradeRegistrationNumber: "",
  commissionProfileCode: "",
  webSite: "",
  taxNumber: "",
  taxOfficeCode: "",
  mcc: "",
  originalMcc: "",
  posList: {},
  merchantType: "",
  closedDate: null,
  annulmentCode: "",
  annulmentStaff: "",
  annulmentCodeDesc: "",
  passiveReason: "",
  isPaymentDescriptionActive: false,
  paymentDescriptionPlaceholder: '',
  isUnlimitedLink: false,
  integrationTypeId: 0,
  userPortfolioId: "",
  linkPaymentHour: 1,
  linkQuantity: 1,
  hasGiroRestriction: false,
  hasAutomaticGiroLimitIncrease: false,
  giroLimit: 0,
  commercialFlag: false,
  corporateFlag: false,
  sectorId: 0,
  isInvoiceSendAsEmailEnabled: false,
  invoiceEmail: '',
  erpCustomerCode: null,
  integratorId: "30",
  integratorUid: '',
  integratorPwd: '',
  integratorGbAlias: '',
  integratorEArchiveGbAlias: '',
  walletNo: '',
  eftDescription: '',
  paymentBlockedDay: null,
  blockedDay: null,
  isPayoutBlocked: false,
  payoutBlockReason: '',
  addressLine1: null, addressLine2: null, cityId: 0, districtId: 0, mobilePhoneNumber: null,
  vPosIntegrationStatus: "",
  zipCode: null, emailAddress1: null, emailAddress2: null, faxNumber: null, addressPhoneNumber: null,
  merchantStatusDescription: null,
  editorDescription: '',
  isCallbackUrlControl: false,
  callbackUrl: "",
  employeeCount: 0,
  estimatedGiro: 0,
};

export const secondStepFormSchema = zod.object({
  addressLine1: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  addressLine2: zod.any().optional(),
  cityId: zod.union([zod.string().nonempty("Please select a city."), zod.number().positive("Please select a valid city.")])
  ,
  districtId: zod.union([
    zod.string().nonempty("Please select a district."),
    zod.number()
  ]),
  mobilePhoneNumber: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string()
  ),
  zipCode: zod.string().min(1, { message: "Please enter your phone number" }),
  emailAddress1: zod.string(),
  emailAddress2: zod.string().optional(),
  faxNumber: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string()
  ),
  phoneNumber: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string()
  ),
});

export type SecondStepFormValuesType = zod.infer<typeof secondStepFormSchema>;

export const secondStepInitialValues: SecondStepFormValuesType = {
  addressLine1: "",
  addressLine2: "",
  cityId: null,
  districtId: "",
  mobilePhoneNumber: "",
  zipCode: "",
  emailAddress1: "",
  emailAddress2: "",
  faxNumber: "",
  phoneNumber: "",
};

export const thirdStepFormSchema = zod.object({
  currencyCode: zod.string(),
  iban: zod
    .string()
    .regex(
      new RegExp(
        /^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/
      ),
      "Name should contain only alphabets"
    ),
  bankCode: zod.string().min(1, { message: "Please enter your phone number" }),
  accountOwner: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),

  currencyCode1: zod.any(),
  iban1: zod
    .string()
    .optional()
    .refine(value =>
      value === "" ||
      value === "0" ||
      /^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/.test(value),
      "Invalid format"),

  bankCode1: zod.any(),
  accountOwner1: zod.any(),
  currencyCode2: zod.any(),
  iban2: zod
    .string()
    .optional()
    .refine(value =>
      value === "" ||
      value === "0" ||
      /^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/.test(value),
      "Invalid format"),
  bankCode2: zod.any(),
  accountOwner2: zod.any()
});

export type ThirdStepFormValuesType = zod.infer<typeof thirdStepFormSchema>;

export const thirdStepInitialValues: ThirdStepFormValuesType = {
  currencyCode: "",
  bankCode: "",
  iban: "",
  accountOwner: "",
  iban1: "",
  bankCode1: "",
  accountOwner1: "",
  currencyCode2: "",
  iban2: "",
  bankCode2: "",
  accountOwner2: "",
};


export const fourthStepFormSchema = zod.object({
  try: zod.any(),
  usd: zod.any(),
  eur: zod.any(),
});

export type FourthStepFormValuesType = zod.infer<typeof fourthStepFormSchema>;

export const fourthStepInitialValues: FourthStepFormValuesType = {
  try: true,
  usd: false,
  eur: false,
};



export const partnerStepFormSchema = zod.object({
  officialFullName: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  officialCitizenNumber: zod
    .string()
    .min(11, { message: "Please enter your phone number" }),
  officialMobilePhone: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string().min(1, { message: "Please enter the mobile phone of partner one" }),
  ),

  officialBirthDate: zod.any(),

  partnerOneFullName: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerOneCitizenNumber: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerOneMobilePhone: zod.preprocess(
    (val) =>
      String(val)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string().optional(),
  ),
  partnerOneBirthDate: zod.any(),
  partnerOnePercent: zod.any(),
  partnerOneType: zod.any(),

  partnerTwoFullName: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerTwoCitizenNumber: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerTwoMobilePhone: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string().optional()
  ),
  partnerTwoBirthDate: zod.any(),
  partnerTwoPercent: zod.any(),
  partnerTwoType: zod.any(),

  partnerThreeFullName: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerThreeCitizenNumber: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerThreeMobilePhone: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string().optional()
  ),
  partnerThreeBirthDate: zod.any(),
  partnerThreePercent: zod.any(),
  partnerThreeType: zod.any(),

  partnerFourFullName: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerFourCitizenNumber: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerFourMobilePhone: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string().optional()
  ),
  partnerFourBirthDate: zod.any(),
  partnerFourPercent: zod.any(),
  partnerFourType: zod.any(),

  partnerFiveFullName: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerFiveCitizenNumber: zod.preprocess(
    (val) => String(val).trim(),
    zod.string().optional()
  ),
  partnerFiveMobilePhone: zod.preprocess(
    (val) =>
      String(val)
        .slice(1)
        .replaceAll("_", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "")
        .trim(),
    zod.string().optional()
  ),
  partnerFiveBirthDate: zod.any(),
  partnerFivePercent: zod.any(),
  partnerFiveType: zod.any(),
});

export type PartnerStepFormValuesType = zod.infer<typeof partnerStepFormSchema>;


export const partnerStepInitialValues: PartnerStepFormValuesType = {

  officialFullName: "",
  officialCitizenNumber: "",
  officialMobilePhone: "",
  officialBirthDate: "",
  partnerOneFullName: "",
  partnerOneCitizenNumber: "",
  partnerOneMobilePhone: "",
  partnerOneBirthDate: "",
  partnerOnePercent: 0,
  partnerOneType: "G",
  partnerTwoFullName: "",
  partnerTwoCitizenNumber: "",
  partnerTwoMobilePhone: "",
  partnerTwoBirthDate: "",
  partnerTwoPercent: 0,
  partnerTwoType: "G",
  partnerThreeFullName: "",
  partnerThreeCitizenNumber: "",
  partnerThreeMobilePhone: "",
  partnerThreeBirthDate: "",
  partnerThreePercent: 0,
  partnerThreeType: "G",
  partnerFourFullName: "",
  partnerFourCitizenNumber: "",
  partnerFourMobilePhone: "",
  partnerFourBirthDate: "",
  partnerFourPercent: 0,
  partnerFourType: "G",
  partnerFiveFullName: "",
  partnerFiveCitizenNumber: "",
  partnerFiveMobilePhone: "",
  partnerFiveBirthDate: "",
  partnerFivePercent: 0,
  partnerFiveType: "G",
};

export const merchantAuthFormSchema = zod.object({
  merchantId: zod.any(),
  bankCodes: zod.any(),
  defaultBank: zod.any(),
});

export type MerchantAuthFormValuesType = zod.infer<
  typeof merchantAuthFormSchema
>;

export const merchantAuthInitialValues: MerchantAuthFormValuesType = {
  merchantId: "",
  bankCodes: [],
  defaultBank: [],
};

export const documentFormSchema = zod.object({
  merchantId: zod
    .union([
      zod.number().positive("Please select a merchant"),
      zod.object({
        label: zod.string(),
        value: zod.number().positive(),
      }),
      zod.number(),
    ]),
  posType: zod.union([zod.string(), zod.number().positive()]),
  companyType: zod.union([zod.string(), zod.number().positive()]),

  files: zod.any(),
  taxNumber: zod.preprocess(
    (val) =>
      String(val)
        .replaceAll("_", "")
        .trim(),
    zod.string().optional()
  ),

});

export type DocumentFormValuesType = zod.infer<typeof documentFormSchema>;

export const documentInitialValues: DocumentFormValuesType = {
  merchantId: 0,
  posType: 0,
  companyType: 0,
  taxNumber: "",
  newLimit: 0
};

export const merchantLimitFilterSchemaType = zod.object({
  startDate: zod.any(),
  endDate: zod.any(),
  newLimit: zod.any(),
  merchantId: zod.number({
    required_error: "Merchant Id is required",
    invalid_type_error: "Merchant Id must be a number",
  })
});

export type MerchantLimitFilterTypes = zod.infer<typeof merchantLimitFilterSchemaType>;

export const merchantLimitFilterInitialValue: MerchantLimitFilterTypes =
{
  startDate: null,
  endDate: null,
  merchantId: 1,
  newLimit: null
};


export const merchantAccoutSchema = zod.object({
  transactionType: zod.number(),
  amount: zod.any(),
  description: zod.string().optional(),
});

export type MerchantAccoutFormValuesType = zod.infer<typeof merchantAccoutSchema>;
